import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SolicitudRegistroService } from '../../services/solicitud-registro.service';

@Component({
  selector: 'app-verificar-registro',
  templateUrl: './verificar-registro.component.html'
})
export class VerificarRegistroComponent implements OnInit {

  dataForm: FormGroup;

  codigoVerificador: string;

  nombres: string;

  apellidos: string;

  disabled:boolean = false;

  sexo:string;
  
  constructor(private service: SolicitudRegistroService, private toastr: ToastrService,
    private fb: FormBuilder, private activatedRoute: ActivatedRoute, private router: Router) {
    this.activatedRoute.params.subscribe(params => {
      this.obtener(params.uuid);
      this.codigoVerificador = params.uuid;
    })
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.dataForm = this.fb.group({
      password: ['', Validators.required],
      passwordRepeat: ['', Validators.required]
    })
  }

  obtener(uuid: string) {
    this.service.obtener(uuid).subscribe(
      resp => {
        this.nombres = resp.nombres;
        this.apellidos = resp.apellidos;
        this.obtenerSexo(resp.sexo);
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  obtenerSexo(dominioId){
    this.service.obtenerSexo(dominioId).subscribe(
      resp => {
        if("MASCULINO" === resp.valor){
          this.sexo = "Estimado";
        } else {
          this.sexo = "Estimada";
        }
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  confirmar() {
    if (this.dataForm.value.password !== this.dataForm.value.passwordRepeat){
      this.toastr.warning('Contraseñas no coinciden, favor verificar', 'Atención');
      return;
    }
    let data = {
      password: this.dataForm.value.password,
      codigoVerificador: this.codigoVerificador
    }
    this.disabled = true;
    this.service.confirmar(data).subscribe(
      (resp: any) => {
        this.disabled = false;
        this.toastr.success('Felicidades! Ya es parte de la familia de HomeBox, recibira un correo con los instructivos', 'Registro Confirmado');
        this.dataForm.reset();
        this.router.navigate([''],{queryParams: {'hb':'1'}});
      }, err => {
        this.disabled = false;
        this.toastr.error(err.error.messages[0], 'Error');
      }
    );
  }

}
